import { message } from "antd";

export const displayGenericError = (errorText) =>
  message.error(
    errorText || "Parece que houve um erro, tente novamente mais tarde!"
  );
